// Tipurile Pasului / zonei «lant» — desprinse din `tipuri.ts`; orice importator
// le ia tot din `./tipuri` (bariera re-exportă fiecare fișier de aici).

// --- lanțul complet, condus de SERVER --------------------------------------
// Butonul „Rulează tot" nu mai iterează pașii din browser: cere o dată ruta
// de mai jos, iar lanțul trăiește în container. Închiderea filei nu îl mai
// oprește, iar lista pașilor e cea de pe server (nicio copie aici).

export type RaportLant = {
  // `se_reia`: rularea a fost tăiată de o repornire de container și e pe drumul
  // de întoarcere — orchestratorul cere continuarea de la pasul la care a
  // rămas. Serverul o DERIVĂ (nu e o stare în bază), iar pentru om e tot „în
  // lucru": soluția n-a devenit gata între timp. V. `lantInLucru`.
  stare:
    | "niciodata"
    | "ruleaza"
    | "se_reia"
    | "gata"
    | "eroare"
    | "intrerupt";
  pasi_ceruti?: string[];
  pasi?: { pas: string; http: number; secunde: number; eroare?: string }[];
  oprit_la?: string | null;
  /** când a pornit rularea (ISO). Cât timp lanțul lucrează, minutele se numără
   *  de aici: `durata_min` se scrie între pași, deci pe un pas lung îngheață. */
  pornit_la?: string | null;
  durata_min?: number;
  nota?: string;
  eroare?: string;
  /** de câte ori a fost reluată rularea după o repornire de container */
  reluari?: number;
  /** clona din care continuă arborele la o reluare a Pasului 19 */
};

/** Rularea NU s-a terminat: fie un worker macină, fie a fost tăiată de o
 *  repornire și se reia. Se citește în patru ecrane (antet, pipeline, soluții,
 *  contextul de date), deci stă o dată: o listă de stări copiată în patru locuri
 *  e o listă care divergează la prima stare nouă. */
export const LANT_IN_LUCRU: ReadonlySet<string> = new Set(["ruleaza", "se_reia"]);

export const lantInLucru = (lant: RaportLant | null | undefined) =>
  !!lant && LANT_IN_LUCRU.has(lant.stare);

// --- reset: șterge rezultatele derivate, păstrează documentele -------------

